var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    id: "_x31_",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    style: {
      width: 24,
      height: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 40.5,
    width: 34.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 55,
    width: 34.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 69.5,
    width: 34.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 40.5,
    width: 34.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 55,
    width: 34.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 69.5,
    width: 34.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,22.4h-5.1v0h-42c-3.9,0-7.3,1.9-9.4,4.7c-2.1-2.8-5.5-4.7-9.4-4.7H9.9c-0.1,0-0.3,0-0.4,0h-2v2.3c0,0,0,0,0,0v65.9   c0,0,0,0,0,0v2.3h6.4v9.4h0.7v0h38.3c0.5,0,0.9,0.2,1.1,0.7c1.3,3.8,4.8,6.4,8.8,6.4h2.4c4,0,7.5-2.6,8.9-6.4   c0.1-0.4,0.6-0.7,1.1-0.7l34.1,0v0h5.1v-9.4h6.2V22.4z M12.6,27.2h42c3.9,0,7.1,3.2,7.1,7.1v56.5c-2-1.5-4.5-2.4-7.1-2.4h-42V27.2z    M75.2,97.8c-2.5,0-4.7,1.5-5.5,3.9c-0.7,1.9-2.5,3.2-4.5,3.2h-2.4c-2,0-3.8-1.3-4.5-3.2c-0.8-2.4-3.1-3.9-5.5-3.9l-33.8,0v-4.8   h35.6c3.9,0,7.1,3.2,7.1,7.1c0,1.3,1.1,2.4,2.4,2.4s2.4-1.1,2.4-2.4c0-3.9,3.2-7.1,7.1-7.1h35.8v4.7L75.2,97.8z M115.4,88.4h-42   c-2.6,0-5.1,0.8-7.1,2.4V34.2c0-3.9,3.2-7.1,7.1-7.1h42V88.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.24de999d54b871d2689fc8257b201597.svg";
export { ForwardRef as ReactComponent };